export function dataLayerPush(data) {
  global.dataLayer = global.dataLayer || []
  global.dataLayer.push(...data)
}
